// import React, { useEffect } from "react";

// function ExamPageStructuredData({
//   examName,
//   vendor,
//   examCode,
//   examDescription,
//   ratingData,
//   ratingCount,
//   examPrice,
// }) {
//   useEffect(() => {
//     // Remove any existing structured data scripts
//     const existingScripts = document.querySelectorAll(
//       'script[type="application/ld+json"]'
//     );
//     existingScripts.forEach((script) => script.remove());

//     // Create and inject product structured data
//     const productScript = document.createElement("script");
//     productScript.type = "application/ld+json";
//     const productStructuredData = {
//       "@context": "https://schema.org",
//       "@type": "Product",
//       name: examName,
//       description: examDescription,
//       sku: examCode,
//       mpn: examCode,
//       brand: {
//         "@type": "Brand",
//         name: vendor,
//       },
//       image: ["https://www.directcertify.com/assets/images/DirectCertify.svg"],
//       offers: {
//         "@type": "Offer",
//         price: examPrice,
//         priceCurrency: "USD",
//         availability: "https://schema.org/InStock",
//         url: `https://www.directcertify.com/${vendor
//           .replace(/ /g, "-")
//           .toLowerCase()}/${examCode}`,
//         priceValidUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
//           .toISOString()
//           .split("T")[0], // 30 days from now
//         seller: {
//           "@type": "Organization",
//           name: "DirectCertify",
//         },
//       },
//       aggregateRating: {
//         "@type": "AggregateRating",
//         ratingValue: ratingData || 5,
//         reviewCount: ratingCount || 1,
//         bestRating: "5",
//         worstRating: "1",
//       },
//     };
//     productScript.innerHTML = JSON.stringify(productStructuredData);
//     document.head.appendChild(productScript);

//     // Create and inject breadcrumb structured data
//     const breadcrumbScript = document.createElement("script");
//     breadcrumbScript.type = "application/ld+json";
//     const breadcrumbStructuredData = {
//       "@context": "https://schema.org",
//       "@type": "BreadcrumbList",
//       itemListElement: [
//         {
//           "@type": "ListItem",
//           position: 1,
//           name: "Home",
//           item: "https://www.directcertify.com",
//         },
//         {
//           "@type": "ListItem",
//           position: 2,
//           name: vendor,
//           item: `https://www.directcertify.com/${vendor
//             .replace(/ /g, "-")
//             .toLowerCase()}`,
//         },
//         {
//           "@type": "ListItem",
//           position: 3,
//           name: examCode,
//           item: `https://www.directcertify.com/${vendor
//             .replace(/ /g, "-")
//             .toLowerCase()}/${examCode}`,
//         },
//       ],
//     };
//     breadcrumbScript.innerHTML = JSON.stringify(breadcrumbStructuredData);
//     document.head.appendChild(breadcrumbScript);

//     // Cleanup function
//     return () => {
//       const scripts = document.querySelectorAll(
//         'script[type="application/ld+json"]'
//       );
//       scripts.forEach((script) => script.remove());
//     };
//   }, [
//     examName,
//     vendor,
//     examCode,
//     examDescription,
//     ratingData,
//     ratingCount,
//     examPrice,
//   ]);

//   // Component doesn't need to render anything
//   return null;
// }

// export default ExamPageStructuredData;
import React, { useEffect } from "react";

function ExamPageStructuredData({
  examName,
  vendor,
  examCode,
  examDescription,
  ratingData,
  ratingCount,
  examPrice,
}) {
  useEffect(() => {
    // Remove any existing structured data scripts
    const existingScripts = document.querySelectorAll(
      'script[type="application/ld+json"]'
    );
    existingScripts.forEach((script) => script.remove());

    // Create and inject product structured data
    const productScript = document.createElement("script");
    productScript.type = "application/ld+json";
    const productStructuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: examName,
      description: examDescription,
      sku: examCode,
      mpn: examCode,
      brand: {
        "@type": "Brand",
        name: vendor,
      },
      image: ["https://www.directcertify.com/assets/images/DirectCertify.svg"],
      offers: {
        "@type": "Offer",
        price: examPrice,
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        url: `https://www.directcertify.com/${vendor
          .replace(/ /g, "-")
          .toLowerCase()}/${examCode}`,
        priceValidUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0], // 30 days from now
        seller: {
          "@type": "Organization",
          name: "DirectCertify",
        },
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: ratingData || 5,
        reviewCount: ratingCount || 1,
        bestRating: "5",
        worstRating: "1",
      },
    };
    productScript.innerHTML = JSON.stringify(productStructuredData);
    document.head.appendChild(productScript);

    // Create and inject breadcrumb structured data
    const breadcrumbScript = document.createElement("script");
    breadcrumbScript.type = "application/ld+json";
    const breadcrumbStructuredData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: {
            "@id": "https://www.directcertify.com",
            name: "Home",
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          item: {
            "@id": `https://www.directcertify.com/${vendor
              .replace(/ /g, "-")
              .toLowerCase()}`,
            name: vendor,
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          item: {
            "@id": `https://www.directcertify.com/${vendor
              .replace(/ /g, "-")
              .toLowerCase()}/${examCode}`,
            name: examCode,
          },
        },
      ],
    };
    breadcrumbScript.innerHTML = JSON.stringify(breadcrumbStructuredData);
    document.head.appendChild(breadcrumbScript);

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, [
    examName,
    vendor,
    examCode,
    examDescription,
    ratingData,
    ratingCount,
    examPrice,
  ]);

  // Component doesn't need to render anything
  return null;
}

export default ExamPageStructuredData;
